var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDomainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2459 18.2415C14.9434 18.2415 18.7515 14.4334 18.7515 9.73586C18.7515 5.03833 14.9434 1.23022 10.2459 1.23022C5.54834 1.23022 1.74023 5.03833 1.74023 9.73586C1.74023 14.4334 5.54834 18.2415 10.2459 18.2415Z",
    stroke: "#CFD0E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74023 9.73584H18.7515",
    stroke: "#CFD0E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.246 1.23022C12.3735 3.55937 13.5826 6.582 13.6483 9.73586C13.5826 12.8897 12.3735 15.9124 10.246 18.2415C8.11851 15.9124 6.90945 12.8897 6.84375 9.73586C6.90945 6.582 8.11851 3.55937 10.246 1.23022V1.23022Z",
    stroke: "#CFD0E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainIcon);
export default __webpack_public_path__ + "static/media/domain_icon.d4d3fdd95fde4b71245131d0c3360566.svg";
export { ForwardRef as ReactComponent };